/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import { Panel } from 'react-bootstrap';
import _ from 'lodash';

// TODO once es6 config is merged create a higher order wrapper for all modals
// TODO refactor this - seems weird and dirty passing {marks} as a prop
class QuizAttemptPanel extends Component {
  state = {
    show: false,
  };

  createInstructionsMarkup = () => {
    return { __html: this.props.chunk.getIn(['question', 'instructions']) };
  };

  toggle = () => {
    this.setState({
      show: !this.state.show,
    });
  };

  renderAnswer = () => {
    return this.props.chunk.getIn(['last_attempt', 'answer']);
  };

  renderMessage = () => {
    if (_.includes(this.props.marks, '-')) {
      return (
        <span>
          Student has not yet marked <a onClick={this.toggle}>their response</a>
        </span>
      );
    }
    return (
      <span>
        Student marked <a onClick={this.toggle}>their response:</a>{' '}
        {this.props.marks}
      </span>
    );
  };

  render() {
    return (
      <span>
        {this.renderMessage()}
        <Panel className="quiz-attempt-panel" expanded={this.state.show}>
          <Panel.Collapse>
            <Panel.Body>
              <span
                className="instructions"
                dangerouslySetInnerHTML={this.createInstructionsMarkup()}
              />
              <span>{this.renderAnswer()}</span>
            </Panel.Body>
          </Panel.Collapse>
        </Panel>
      </span>
    );
  }
}

export default QuizAttemptPanel;
